import axios from "axios";

const agents = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getFactorList(context, payload) {
            let response = await axios.get(`/agents/get_agents_factor_list/${payload.startDate}/${payload.endDate}/${payload.userId}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCommisionFactorList(context, payload) {
            let response = await axios.get(`/agents/get_agents_commision_factor_list/${payload.startDate}/${payload.endDate}/${payload.userId}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getCommisionFactorListNotInclude(context, payload) {
            let response = await axios.get(`/agents/get_agents_commision_factor_list_not_include/${payload.startDate}/${payload.endDate}/${payload.userId}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getGoodsCommissionDetails(context, payload) {
            let response = await axios.get(`/agents/get_commission_with_goods_special_date/${payload.startDate}/${payload.endDate}/${payload.userId}/${payload.goodsCode}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getSummaryGoodsCommission(context, payload) {
            let response = await axios.get(`/agents/get_summary_commission_with_goods_special_date/${payload.startDate}/${payload.endDate}/${payload.userId}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getVisitorRewardByCustomerRegister(context, payload) {
            let response = await axios.get(`/agents/get_visitor_reward_by_customer_register/${payload.startDate}/${payload.endDate}/${payload.userId}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getAgentNotPayFactor(context, payload) {
            let response = await axios.get(`/agents/get_agent_not_pay_factor/${payload.startDate}/${payload.endDate}/${payload.userId}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async addCommissionFinanceDocument(context, payload) {
            let response = await axios.post(`/agents/add_commission_finance_document`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
    },
    getters: {}
}

export default agents;
